
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 5c2.451 0 4.563 1.302 5.813 3.219.392-.089.755-.219 1.188-.219 3.302 0 6 2.698 6 6 1.73 1.055 3 2.835 3 5 0 3.302-2.698 6-6 6h-20c-3.302 0-6-2.698-6-6s2.698-6 6-6c.211 0 .394.04.594.063.531-1.191 1.439-2.083 2.656-2.563.698-3.129 3.419-5.5 6.75-5.5zm0 2a4.972 4.972 0 00-4.938 4.25l-.094.688-.656.156c-1.11.265-2.002 1.136-2.25 2.25l-.188.969-1-.219A3.931 3.931 0 005.999 15c-2.22 0-4 1.78-4 4s1.78 4 4 4h20c2.22 0 4-1.78 4-4a4.008 4.008 0 00-2.438-3.688l-.656-.281.063-.719c.018-.235.031-.321.031-.313 0-2.22-1.78-4-4-4-.444 0-.875.096-1.313.25l-.844.281-.375-.781a4.998 4.998 0 00-4.469-2.75z"}})])
          )
        }
      }
    